var scrollRevealHandler = {
  scrollTimer: null,
  offset: 0.75,
  init: function() {
    var self = this;
    // stagger scroll reveal animation
    $('[data-scroll-reveal]').each(function() {
      var scrollAnimDelay = $(this).css('--scroll-anim-stagger-delay');
      var delayCounter = 0;
      $(this).find('[data-scroll-reveal-item]').each(function(index, element) {
        var $current = $(this);
        $current.children().each(function() {
          $(this).css('transition-delay', (parseInt(scrollAnimDelay) * delayCounter)+'ms');
          delayCounter++;
        });
        
      })
    });
    $(window).on("scroll", function() {
      self.showElements();
    });
    $(window).on("load", function() {
      setTimeout(function() {
        self.showElements();
      }, 250);  
    });
  },
  showElements: function() {
    var self = this;
    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();
    $('[data-scroll-reveal]').not('.scroll-revealed').each(function() {
      var $current = $(this);
      if ($current.offset().top < windowTop + self.offset * $(window).height()) {
        $current.addClass('scroll-revealed');
      }
    });
  },
}

scrollRevealHandler.init(); 
